import Vue from "vue";
import {
  Button,
  message,
  Layout,
  Menu,
  Icon,
  Spin,
  Dropdown,
  Avatar,
  Tabs,
  Table,
  Tag,
  List,
  Badge,
  Modal,
  Form,
  Input,
  Descriptions,
  Divider,
  Row,
  Col,
  Calendar,
  DatePicker,
  Empty,
  Radio,
  Progress,
  ConfigProvider,
  Space,
  Steps,
  PageHeader,
  Upload,
  Select,
  Drawer,
  Switch,
  InputNumber,
  Tree,
  Alert,
  Card,
  Anchor,
  Collapse,
  Tooltip,
  Popover,
  Skeleton,
  Checkbox,
  Timeline,
  Popconfirm,
  FormModel,
  Carousel,
  TreeSelect,
  Transfer,
  notification,
  Affix,
} from "ant-design-vue";

Vue.use(Button);
Vue.use(Layout);
Vue.use(Menu);
Vue.use(Icon);
Vue.use(Spin);
Vue.use(Dropdown);
Vue.use(Avatar);
Vue.use(Tabs);
Vue.use(Table);
Vue.use(Tag);
Vue.use(List);
Vue.use(Badge);
Vue.use(Modal);
Vue.use(Form);
Vue.use(FormModel);
Vue.use(Input);
Vue.use(Descriptions);
Vue.use(Divider);
Vue.use(Row);
Vue.use(Col);
Vue.use(Calendar);
Vue.use(DatePicker);
Vue.use(Empty);
Vue.use(Radio);
Vue.use(Progress);
Vue.use(ConfigProvider);
Vue.use(Space);
Vue.use(PageHeader);
Vue.use(Steps);
Vue.use(Upload);
Vue.use(Select);
Vue.use(Drawer);
Vue.use(Switch);
Vue.use(InputNumber);
Vue.use(Tree);
Vue.use(Alert);
Vue.use(Tree);
Vue.use(Card);
Vue.use(Anchor);
Vue.use(Collapse);
Vue.use(Tooltip);
Vue.use(Popover);
Vue.use(Skeleton);
Vue.use(Checkbox);
Vue.use(Timeline);
Vue.use(Popconfirm);
Vue.use(Carousel);
Vue.use(TreeSelect);
Vue.use(Transfer);
Vue.use(Affix);
Vue.prototype.$message = message;
Vue.prototype.$notification = notification;
Vue.prototype.$modal = Modal;
Vue.prototype.$info = Modal.info;
Vue.prototype.$success = Modal.success;
Vue.prototype.$error = Modal.error;
Vue.prototype.$warning = Modal.warning;
Vue.prototype.$confirm = Modal.confirm;
Vue.prototype.$destroyAll = Modal.destroyAll;

Vue.component(`vChart`, () =>
  import(/* webpackChunkName: "vChart" */ `@/components/echarts/VEcharts`)
);
